import AgencyHelper from 'features/Agency/agencyHelper';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTRadio, {
  KTRadioType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import ImageView from 'general/components/quybka/Images/ImageView';
import AppColors from 'general/constants/AppColors';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useState } from 'react';
import './index.scss';

AgencySaleInvoiceView.propTypes = {
  saleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  saleCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function AgencySaleInvoiceView({ saleId, saleCode, onCancel, onDone }) {
  const [invoiceType, setInvoiceType] = useState('PAPER');
  const [invoiceSerial, setInvoiceSerial] = useState('');
  const [invoiceDocumentFile, setInvoiceDocumentFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!invoiceSerial || !invoiceDocumentFile) {
      ToastHelper.showError('Vui lòng nhập đầy đủ thông tin hóa đơn');
      return;
    }

    setLoading(true);
    const mediaList = await miscHelper.callApiUploadFile(invoiceDocumentFile);
    const invoiceDocument = _.first(mediaList)?.relativePath;

    if (!invoiceDocument) {
      ToastHelper.showError('Tải file hóa đơn thất bại');
      setLoading(false);
      return;
    }

    const result = await AgencyHelper.API.requestUpdateSaleInvoice(saleId, {
      invoiceDocument,
      invoiceSerial,
    });

    if (result === true) {
      ToastHelper.showSuccess('Xuất hóa đơn thành công');
      onDone?.();
    } else {
      ToastHelper.showError(result || 'Xuất hóa đơn thất bại');
    }
    setLoading(false);
  };

  return (
    <div className="agency-sale-invoice">
      <div className="text-center px-4 pt-5">
        <div style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>
          Xuất hóa đơn
        </div>
        <div className="mt-1" style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
          Bạn muốn xuất hóa đơn cho đơn hàng:{' '}
          <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[700])}>
            {saleCode ?? saleId}
          </span>
          ?
        </div>
      </div>

      <div className="d-flex align-items-center gap-5 px-4 py-3 invoice-type-options">
        <KTRadio
          name="electronicInvoice"
          label="Hóa đơn điện tử"
          type={KTRadioType.outline}
          additionalClassName="radio-success"
          checked={invoiceType === 'ELECTRONIC'}
          onChange={() => setInvoiceType('ELECTRONIC')}
        />
        <KTRadio
          name="paperInvoice"
          label="Hóa đơn giấy"
          type={KTRadioType.outline}
          additionalClassName="radio-success"
          checked={invoiceType === 'PAPER'}
          onChange={() => setInvoiceType('PAPER')}
        />
      </div>

      <div className="px-4 py-3">
        <div className="mb-4">
          {UIHelper.buildFormLabel('Số hóa đơn', true, true, 'mb-2', { fontSize: '15px' })}
          <KTFormInput
            name="invoiceSerial"
            type={KTFormInputType.text}
            value={invoiceSerial}
            placeholder="Nhập số hóa đơn"
            onChange={setInvoiceSerial}
          />
        </div>
        <div>
          {UIHelper.buildFormLabel('Tải lên file hóa đơn', true, true, 'mb-2', {
            fontSize: '15px',
          })}
          <label>
            {UIHelper.buildNegativeButton(
              'Thêm tệp tin',
              () => {},
              <i className="fa-regular fa-upload" />
            )}
            <input
              hidden
              type="file"
              accept=".pdf,application/pdf"
              onClick={(event) => {
                event.target.value = null;
              }}
              onChange={(event) => {
                const file = event.target.files?.[0];
                if (!file) return;
                if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
                  ToastHelper.showError('Vui lòng chọn file định dạng PDF');
                  return;
                }
                if (file.name.length > 128) {
                  ToastHelper.showError('Tên file quá dài! Tối đa cho phép 128 ký tự.');
                  return;
                }
                setInvoiceDocumentFile(file);
              }}
            />
          </label>
          {invoiceDocumentFile && (
            <ImageView
              name={invoiceDocumentFile.name}
              fileName={invoiceDocumentFile.name}
              path={invoiceDocumentFile.name}
            />
          )}
        </div>
      </div>

      <div
        className="d-flex align-items-center gap-3 px-4 py-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Xác nhận', handleSubmit, null, true, loading)}
      </div>
    </div>
  );
}

export default AgencySaleInvoiceView;
